module.exports = __webpack_public_path__ + "CrossStitchParlour.webp?786f0c23eab586cbe5e014042883ecc0";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CrossStitchParlour.webp
// module id = 70
// module chunks = 0